import { REGEX_PUNCTUATION_WITHOUT_SPACE } from '@/common/constants/regex/typographyRegex';

/** Нормализует пробелы в тексте */
export const normalizeItemsTextSpacing = (items: unknown[]): unknown[] => {
  return items.map(normalizeTextSpacingValue);
};
export const normalizeTextSpacingValue = (value: unknown): unknown => {
  if (typeof value === 'string' && REGEX_PUNCTUATION_WITHOUT_SPACE.test(value)) {
    return value.replace(REGEX_PUNCTUATION_WITHOUT_SPACE, '$1 ');
  }

  if (Array.isArray(value)) {
    return normalizeItemsTextSpacing(value);
  }

  if (value && typeof value === 'object') {
    const normalizedObject: Record<string, unknown> = {};
    Object.entries(value).forEach(([key, nestedValue]) => {
      normalizedObject[key] = normalizeTextSpacingValue(nestedValue);
    });
    return normalizedObject;
  }

  return value;
};
